<ng-container *ngIf="errorMessage$ | async as message">
  {{ message }}
</ng-container>
